import { API_STATUS } from "../../../constants/apiStatus";

export const userProfileSliceInitialState = {
  profile: null,
  apiStatus: {
    getProfile: API_STATUS.IDLE,
    updateProfile: API_STATUS.IDLE,
    uploadAvatar: API_STATUS.IDLE,
  },
  error: null,
};
